export class DataService {
    constructor(events) {
        this.events = events;
        this._products = [];
    }
    set products(data) {
        this._products = data;
        this.events.emit('products:received');
    }
    get products() {
        return this._products;
    }
    modalWindowProduct(item) {
        this.product = item;
        this.events.emit('modalWindow:open', item);
    }
}
